<nav class="navbar navbar-expand-lg navbar-light bg-white position-fixed top-0 start-0 w-100 py-3 z-3 epf-navbar">
  <div class="container-fluid d-flex align-items-center">

    <!-- LEFT: logo (uses your brand-logo class from CSS) -->
    <a href="#" class="navbar-brand brand-logo m-0" aria-label="Home"></a>

    <button
      class="navbar-toggler ms-auto"
      type="button"
      data-bs-toggle="collapse"
      data-bs-target="#epf_navbar"
      aria-controls="epf_navbar"
      aria-expanded="false"
      aria-label="Toggle navigation"
    >
      <span class="navbar-toggler-icon"></span>
    </button>

    <div class="collapse navbar-collapse text-xs" id="epf_navbar">
      <ul class="navbar-nav mx-lg-auto mb-2 mb-lg-0 text-uppercase fw-semibold">
        <li class="nav-item"><a class="nav-link nav-underline px-lg-3" href="#ProblemSection">The Crisis</a></li>
        <li class="nav-item"><a class="nav-link nav-underline px-lg-3" href="#ImpactEcosystemSection">How It Works</a></li>
        <li class="nav-item"><a class="nav-link nav-underline px-lg-3" href="#SustainableSocialImpactNote">The SSIN</a></li>
        <li class="nav-item"><a class="nav-link nav-underline px-lg-3" href="#ChooseYourLegacySection">Assets</a></li>
        <li class="nav-item"><a class="nav-link nav-underline px-lg-3" href="#GovernanceLockSection">Governance</a></li>
      </ul>

      <router-link
        to="/login"
        class="btn btn-primary btn-sm text-xs text-uppercase fw-light px-4 py-2 rounded-3 epf-cta"
      >
        Adopt an Asset
      </router-link>

    </div>

  </div>
</nav>
